import PrivateCard from './PrivateCard';

export default PrivateCard;
